<template>
  <div id="app">
    <transition name="slide-fade">
      <router-view/>
    </transition>
    <user-banned-modal-handler/>
    <console-brand/>
  </div>
</template>

<script>
  import ConsoleBrand from "./components/ConsoleBrand";
  import UserBannedModalHandler from "./components/UserBannedModalHandler";

  export default {
    name: 'app',
    components: {
      ConsoleBrand,
      UserBannedModalHandler,
    },
  }
</script>

<style lang="scss">
  @import './styles/fonts.scss';
  @import './styles/variables.scss';

  .g-recaptcha{
    display: inline-block;
  }

  .captcha-container{
    text-align: center;
    min-width: 305px;
    display: block;
    margin-bottom: 1em;

    .error-message{
      font-size: .75em;
      margin: 0;
      color: #f57f6c;
    }

    & > div{
      text-align: center;

      & > div {
        display: inline-block;
      }
    }
  }

  body{
    background-color: $pallete_dark_color;
    margin: 0;
    padding: 0;
  }

  a{
    color: inherit;
    text-decoration: none;
  }

  .container{
    max-width: 1280px;
    display: block;
    margin: auto;
  }

  main.content{
    min-height: 500px;
  }

  #app {
    font-family: 'd-din', 'Raleway', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  *{
    box-sizing: border-box;
  }


  .form-group {
    text-align: left;
    margin-bottom: 1em;

    &.error{
      .form-control {
        border-bottom: 1px solid $pallete_error_color;

        &:focus{
          border-bottom: 1px solid $pallete_error_color;
        }
      }

      label{
        color: $pallete_error_color;
      }
    }

    .input-group{
        display: block;

        .form-control {
            &:not(:last-child){
                margin-right: .5em;
            }
        }
    }


    .error-message{
      font-size: .75em;
      margin: 0;
      color: $pallete_error_color;
    }
  }

  .form-control {
    display: block;
    width: 100%;
    padding: .5em;
    border: none;
    background-color: $pallete_clear_color;

    &:focus{
      border: none;
      box-shadow: none;
      outline: none;
    }
  }

  button, .btn{
    background-color: $pallete_secondary_color;
    transition: background-color 1s ease;
    border: none;
    padding: .5em;

    &:focus{
      border: none;
      box-shadow: none;
      outline: none;
    }

    &:hover{
      background-color: darken($pallete_secondary_color, 25%);
    }
  }

  table.table{
    display: table;
    width: 100%;
    border-spacing: 0;
    margin-bottom: 1rem;

    thead{
      tr {
        background-color: rgba(125,125,125,.5);

        th {
          padding: .75em;
        }
      }
    }

    tbody{
      tr{
        td{
          border-bottom: 1px solid $pallete_secondary_color;

          padding: .75em;
        }
      }
    }
  }

  .loadable{
    position: relative;

    .loader-wrapper{
      display: none;
      position: absolute;
      top: calc(50% - 50px);
      left: calc(50% - 25px);
    }

    &:after{
      position: absolute;
      display: block;
      visibility: hidden;
      opacity: 0;
      content: "";
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: rgba(255, 255, 255, 0.7);
      transition: all .2s ease;
      z-index: 2;
    }

    &.loading{
      &:after{
        visibility: visible;
        opacity: 1;
      }

      .loader-wrapper{
        display: block;
      }
    }
  }

  .failable{
    position: relative;

    .failed-wrapper{
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    &:after{
      position: absolute;
      display: block;
      visibility: hidden;
      opacity: 0;
      content: "";
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: rgba(0, 0, 0, 0.35);
      transition: all .2s ease;
      z-index: 0;
    }

    &.failed{
      &:after{
        visibility: visible;
        opacity: 1;
      }

      .failed-wrapper{
        display: block;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
    }
  }

  button{
    cursor: pointer;
  }

  .btn.main{
    background-color: $pallete_main_color;
    transition: background-color .5s ease;
    color: $pallete_clear_text_color;
    font-weight: bold;

    &:hover{
      background-color: darken($pallete_main_color, 10%);
    }
  }

  .main-btn{
    background-color: $pallete_main_color;
    transition: background-color .5s ease;
    color: $pallete_clear_text_color;
    font-weight: bold;
    font-size: .9em;
    padding: 1em;

    &:hover{
      background-color: darken($pallete_main_color, 10%);
    }
  }

  .dark{
    background-color: lighten($pallete_dark_color, 15%);
    color: $pallete_clear_text_color;

    section{
      & > h1,h2,h3,h4,h5,h6{

        &.title{
          color: $pallete_clear_text_color;
        }
      }
    }
  }

  section{
    &:not(:last-child){
      margin-bottom: 30px;
    }

    & > h1,h2,h3,h4,h5,h6{

      &.title{
        border-top: 10px solid $pallete_main_color;
        color: #000000;
        padding: .33em;
        font-size: 1.4em;
        text-align: left;
        margin: 0;
        text-transform: uppercase;
        display: inline-block;
      }
    }

    @media(max-width: 768px){
      margin-bottom: 50px;
      word-break: break-word;
    }
  }

  @keyframes glow {
    from { opacity: .75; }
    to { opacity: .35; }
  }

  .placeholder{
    animation: glow .5s ease-in alternate infinite;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
